import type { Event } from '../types';

export const DirverLicenseEventData = {
  DriverLicenseLinkSubmitted: {
    eventAction: 'DriverLicenseLinkSubmitted',
  } as Event<''>,
};
